import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../AuthContext';
import axios from 'axios';
import '../dashboard.css';
import { useLocation, useNavigate } from 'react-router-dom';
import UserStatus from './UserStatus';
import API from '../api';
import ConfirmationModal from './ConfirmationModal'; // Import the modal

const Dashboard = () => {
  const { user, login, logout } = useAuth();
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ item: '', buy_price: '', sell_price: '', percent_change: ''});
  const [editingIndex, setEditingIndex] = useState(null);
  const [limitMessage, setLimitMessage] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [saveMessage, setSaveMessage] = useState('');
  const [stockSaveMessage, setStockSaveMessage] = useState('');
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState({name:'', price: ''});
  const [subscriptionStatus, setSubscriptionStatus] = useState('');
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState('');
  const hasFetched = useRef(false);
  const [subscription, setSubscription] = useState(null);
  const [notifyMedium, setNotifyMedium] = useState(1);
  const [expiry_date, setExpiryDate] = useState('');
  const [start_date, setStartDate] = useState('');
  const [linkMessage, setLinkMessage] = useState('');
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [telegramLink, setTelegramLink] = useState('');  
  const [isExpired, setExpired] = useState(false);
  
  const [selectedBrokerage, setSelectedBrokerage] = useState('');

  // Replace these with correct login URLs

  const DSE_BROKERAGES = [
  { id: 'bank_asia', name: 'Bank Asia Securities Ltd.', loginUrl: 'https://login.bankasia-securities.example.com' },
  { id: 'bdbl', name: 'BDBL Securities Ltd.', loginUrl: 'https://login.bdblsecurities.example.com' },
  { id: 'brac_epl', name: 'BRAC EPL Stock Brokerage Ltd.', loginUrl: 'https://login.brac-epl.example.com' },
  { id: 'tkssl', name: 'TK Shares & Securities Ltd.', loginUrl: 'https://login.tksslb.example.com' },
  { id: 'city_brokerage', name: 'City Brokerage Ltd.', loginUrl: 'https://login.citybrokerage.example.com' },
  {id: 'globe_brokerage', name: 'Globe Securities Ltd.', loginUrl: 'https://www.gifc.com.bd/Home/login'}
  // Add more, ensuring loginUrl is correct
];

  const formatDate = (datetime) => {
  const date = new Date(datetime);  
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });
  };
  
const isFree = subscription === 1;
const isPaid = subscription === 2 || subscription === 3 || subscription === 4;
const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 769);
  
useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 769) {
        setSidebarOpen(true);  // open sidebar on desktop
      } else {
        setSidebarOpen(false); // closed on mobile
      }
    };

    handleResize(); // run on mount

    // Optional: listen for window resize to update sidebar automatically
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  
useEffect(() => {
  document.title = "Dashboard | TradeBarta.com";
}, []);

// First effect: fetch subscription info when user is loaded
useEffect(() => {
  if (!user?.id) return;
  fetchSubscription();
}, [user]);

// Second effect: react when subscription is fetched
useEffect(() => {
  if (!user?.id || !subscription) return;
  fetch(`${process.env.REACT_APP_API_URL}/api/load-portfolio?user_id=${user.id}&package_id=${subscription}`, {
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json'
    }
  })
    .then(res => res.json())
    .then(data => {
      if (data.stocks) {
        const normalizedStocks = data.stocks.map(stock => ({
          ...stock,
          buy_price: Number(stock.buy_price),
          sell_price: Number(stock.sell_price),
          percent_change: Number(stock.percent_change),
          price_notify: Boolean(stock.price_notify),
          news_notify: Boolean(stock.news_notify)
        }));
        setRows(normalizedStocks);
      }
    })
    .catch(err => console.error('Failed to fetch stocks:', err));
    
  fetch(`${process.env.REACT_APP_API_URL}/api/load_notify_config?user_id=${user.id}&package_id=${subscription}`, {
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json'
    }
  })
    .then(res => res.json())
    .then(data => {
      if (data.config) {
      setPhoneNumber(data.config.phone_number); // use snake_case if that's your DB column

      if (data.config.notify_medium === 1 || data.config.notify_medium === 2) {
        setNotifyMedium(data.config.notify_medium);
}

    }
    })
    .catch(err => {
      console.error('Failed to fetch Notify Configuration:', err);
    });
}, [subscription, user]);

// Third effect: load stock options and WhatsApp once user is loaded
useEffect(() => {
  if (!user?.id) return;
  console.log(process.env.REACT_APP_API_URL);

  fetch(`${process.env.REACT_APP_API_URL}/api/load_stocks`)
    .then(res => res.json())
    .then(data => {
      if (data) {
        setOptions(data);
      }
    })
    .catch(err => console.error('Failed to fetch stocks:', err));
  
}, [user]);


const fetchSubscription = async () => {
  try {
    if (user) {
      const res = await API.get('/packageid', { params: { user_id: user?.id } });
      const planId = res.data.package_id;
      setSubscription(planId); // store numeric ID (1, 2, 3, 4)
      setStartDate(formatDate(res.data.start_date) || '');   
      setExpiryDate(formatDate(res.data.expiry_date) || '');
      setSubscriptionStatus(res.data.subscriptionStatus || '');
      
      const currentDate = new Date();

      if(planId === 1)
      {
         setNotifyMedium(1);
      } 
  
  const expiry = new Date(res.data.expiry_date);
  setSubscriptionStatus(res.data.status);
  if(expiry < currentDate){
    setExpired(true);  
    setMessage("Your plan has ended on " + formatDate(expiry) + ". Please renew or subscribe to another plan");         
  }
      else if(res.data.status === 'cancelled' && res.data.package_id === 1 && expiry >= currentDate)
    setMessage("You have cancelled your free trial . Your free trial remains active until " + formatDate(expiry));
  else if (res.data.status === 'cancelled' && res.data.package_id != 1 && expiry >= currentDate)
    setMessage("You have cancelled your current subscription. You can continue using the service until " + formatDate(expiry)); 
  }
  
  } catch (err) {
    console.error('Subscription load failed', err);
  }
};

const getMaxRows = () => {
  if (subscription === 1) return 3;
  if (subscription === 2) return 5;
  if (subscription === 3) return 10;
  if (subscription === 4) return 125;
};

const maxRows = getMaxRows();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
const handleAdd = () => {
  
  if (!selected || !form.buy_price || !form.sell_price || !form.percent_change) return;

  const current = options.find((option) => option.name === selected)?.current_price;

  if (Number(form.buy_price) >= current){
    setLimitMessage("Buy Alert Price needs to be less than current price");
    return;
  }

  if (Number(form.sell_price) <= current){
    setLimitMessage("Sell Alert Price needs to be greater than current price");
    return;
  }

    if (Number(form.percent_change) > 10){
    setLimitMessage("Max daily percentage change allowed is 10 %");
    return;
  }
  
  if (Number(form.percent_change) === 0){
    setLimitMessage("Daily percentage change must be greater than 0 %");
    return;
  }

  const newRow = {
    item: selected,
    buy_price: Number(form.buy_price),
    sell_price: Number(form.sell_price),
    percent_change: Number(form.percent_change),
    price_notify: true,
    news_notify: true,
  };

  if (editingIndex !== null) {
    const updatedRows = [...rows];
    updatedRows[editingIndex] = newRow;
    setRows(updatedRows);
    setEditingIndex(null)

  } else {
    if (rows.length >= maxRows) {
      setLimitMessage(`Your current package allows only ${maxRows} stocks. Please upgrade to add more.`);
      return;
    }

    const isPresent = rows.some((row) => row.item === selected);
    if (isPresent) {
      setLimitMessage('This stock is already added.');
      return;
    }

    setRows([...rows, newRow]);
  }
  setStockSaveMessage('');

  setForm({ buy_price: '', sell_price: '', percent_change: '' });
  setSelected('');
  setLimitMessage('');
};


const handle_changeplan = (e) => {
  e.preventDefault();   
  const currentDate = new Date();
  if(!subscription)
    return;
      // Redirect based on selected pricing plan
      if(subscription === 1 || subscription === 2 || subscription === 3)
      {
        navigate('/change_plan');
      }  
      const expiryDate = new Date(expiry_date);
 
      if (subscription === 4 && expiryDate >= currentDate) {
        setLinkMessage("You can downgrade only after your current Platinum plan expires on " + expiry_date);
      }
      if (subscription === 4 && expiryDate < currentDate) {
        navigate('/change_plan');
      }
  };
    

const handle_renew = (e) => {
  e.preventDefault();   
  if(!subscription)
    return;
      // Redirect based on selected pricing plan
      if(subscription === 1)
      {
        setLinkMessage('Cannot Renew Free Trial. Please Upgrade');
        return;
      }  

      if (subscription === 2) {
        const plan = { id: 2, name: 'Silver', price: '300/month', action: 'renewal', features: ['For up to 5 stocks', 'Telegram / SMS Notification', 'Price and News Notification', 'Billed Monthly']};
        setSelectedPlan(plan);
        navigate('/payment', { state: { selectedPlan: plan } });
      }
      if (subscription === 3)
      {
        const plan = { id: 3, name: 'Gold', price: '500/month', action: 'renewal', features: ['For up to 10 stocks', 'Telegram / SMS Notification', 'Price and News Notification', 'Billed Monthly']};
        setSelectedPlan(plan);
        navigate('/payment', { state: { selectedPlan: plan } });
      }  
      if (subscription === 4)
      {
        const plan = { id: 4, name: 'Platinum', price: '1000/month', action: 'renewal', features: ['For 25 stocks', 'Telegram / SMS Notification', 'Price and News Notification', 'Billed Monthly'] };
        setSelectedPlan(plan);
        navigate('/payment', { state: { selectedPlan: plan } });
      }  
  };
    
 const handle_cancel = () => {
    // Show confirmation modal
    setShowModal(true);
  };

  const handleConfirmCancel = async () => {
    try {
      const userId = user?.id;
      if (!userId || !subscription) {
        setErrorMessage('User or subscription missing');
        setShowModal(false); // Close modal on error
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/cancel`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, subscription, action: 'cancel' }),
      });

      const data = await response.json();
      if (response.ok) {
        setErrorMessage('Subscription canceled successfully!');
        //navigate('/Cancel', { state: { subscription } });
      } else {
        setErrorMessage(`Failed to cancel: ${data?.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error cancelling subscription:', error);
      setErrorMessage('An error occurred while cancelling your subscription.');
    }

    // Close the modal after action
    setShowModal(false);
  };

  const handleCancelModal = () => {
    // Simply close the modal if user cancels the action
    setShowModal(false);
  };


  const handleEdit = (index) => {
    const row = rows[index];
  setForm({
    buy_price: row.buy_price,
    sell_price: row.sell_price,
    percent_change: row.percent_change
  });
  setSelected(row.item); // This ensures dropdown reflects the selected stock
  setEditingIndex(index);
  setLimitMessage('');
  };

  const handleDelete = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
    if (editingIndex === index) setEditingIndex(null);
      setLimitMessage('');
  };

  const handleCheckboxToggle = (index, field) => {
  const updatedRows = [...rows];
  updatedRows[index][field] = !updatedRows[index][field];
  setRows(updatedRows);
};

const handlePhoneChange = (e) => {
  let input = e.target.value;

  // Allow only digits, but don't block deletion
  const digitsOnly = input.replace(/\D/g, '');

  // Don't force trim unless actually typing more digits
  if (digitsOnly.length <= 11) {
    setPhoneNumber(digitsOnly);
  } else {
    setPhoneNumber(digitsOnly.slice(0, 11));
  }
};

const handleBuyPriceChange = (e) => {
  let value = e.target.value;

  // Allow only digits and one decimal point
  if (!/^\d*\.?\d*$/.test(value)) return;

  // Limit to max 8 characters including decimal
  if (value.length > 8) return;
  setForm(prev => ({ ...prev, buy_price: value }));
};

const handleSellPriceChange = (e) => {
  let value = e.target.value;

  // Allow only digits and one decimal point
  if (!/^\d*\.?\d*$/.test(value)) return;

  // Limit to max 8 characters including decimal
  if (value.length > 8) return;

  setForm(prev => ({ ...prev, sell_price: value }));
};

const handleMaxChange = (e) => {
  let value = e.target.value;

  // Allow only digits and one decimal point
  if (!/^\d*\.?\d*$/.test(value)) return;

  // Limit to max 8 characters including decimal
  if (value.length > 4) return;

  setForm(prev => ({ ...prev, percent_change: value }));
};

  const handleBrokerageChange = (e) => {
    const selectedId = e.target.value;
    setSelectedBrokerage(selectedId);

    const selected = DSE_BROKERAGES.find(b => b.id === selectedId);
    if (selected && selected.loginUrl) {
      // Open login page in new popup window
      window.open(
        selected.loginUrl, 
        '_blank', 
        'width=800,height=600'
      );
    }
  };


const handleSavePhone = async () => {
  const userId = user?.id;
  const email = user?.email;
  if (!subscription) return;

  const medium = notifyMedium;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/save-phone`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email,
          user_id: userId,
          package_id: subscription,
          phoneNumber: phoneNumber,
          notify_medium: medium,
        }),
      }
    );

    console.log(response);
    const data = await response.json();

    if (response.ok) {
      setSaveMessage(data.message);

      // 👇 capture telegram deep link if backend sent it
      if (data.link) {
        setTelegramLink(data.link);
      } else {
        setTelegramLink(null);
      }
    } else {
      setSaveMessage(`Failed to save: ${data.message || "Unknown error"}`);
      setTelegramLink(null);
    }
  } catch (error) {
    console.error("Error saving Phone number:", error);
    setSaveMessage("An error occurred while saving.");
    setTelegramLink(null);
  }
};

const handleSavePortfolio = async () => {
  const userId = user?.id;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/save-portfolio`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, package_id: subscription, stocks: rows, notify_medium: notifyMedium }),
    });

    const data = await response.json();
    if (response.ok) {
      setStockSaveMessage('Stock configuration saved successfully!');
    } else {
      setStockSaveMessage(`Failed to save: ${data.message}`);
    }
  } catch (error) {
    console.error('Error saving stock data:', error);
    setStockSaveMessage('An error occurred while saving.');
  }
};

  return (
   <div className='dashboard-wrapper'>
          {/* Top Navigation Bar */}
      <header className="header-container">
  <a href="/" className="logo">
    <img src={require("../images/logo.png")} alt="Logo" />
  </a>

                     
                    <button className="menu-toggle" onClick={toggleSidebar}>☰</button>  
     <UserStatus />
          </header>       
      {/* Sidebar and Main Content */}
                    
   <div className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
  
     <aside className={`sidebar ${sidebarOpen ? 'show-sidebar' : ''}`}>
          <ul>
            <li><a href="/dashboard">Dashboard</a></li>
            <li><a href="/payment_history">Billing and Payment History</a></li>
            <li><a href="/referral_dashboard">Refer & Win</a></li>
            <li><a href="/profile">My Profile</a></li>
            <li><a href="/contact_us">Support</a></li>
          </ul>
        </aside>          
      <main className="main-content">
        <section className="data-table">
      <div className="form-row package-header">
  
  <h1>Current Package: <b>{subscription === 1 ? 'Free Trial' : 
                 subscription === 2 ? 'Silver' :
                 subscription === 3 ? 'Gold' :
                 subscription === 4 ? 'Platinum' :
                 subscription}</b></h1>
</div>
      <div className="form-row package-header">
        
  <h6>Start Date: <b>{start_date}</b></h6>
  <h6>Expiry Date: <b>{expiry_date}</b></h6>
</div>

    {message && <p style={{ marginTop: '25px', color: 'red', fontSize: '20px', font: 'bold' }}>{message}</p>}

<div className="form-row package-header">
  <ul className="list-unstyled d-flex flex-wrap flex-md-row gap-2">
    {/* Show Subscribe if plan is cancelled or expired */}
    {(subscriptionStatus === 'cancelled' || isExpired) && (
      <li>
        <a className="btn btn-primary w-10 w-md-auto" onClick={handle_changeplan}>
          Subscribe
        </a>
      </li>
    )}

    {/* Show Change Plan if plan is active and not cancelled */}
    {subscriptionStatus !== 'cancelled' && !isExpired && (
      <li>
        <a className="btn btn-primary w-10 w-md-auto" onClick={handle_changeplan}>
          Change Plan
        </a>
      </li>
    )}

    {/* Show Renew if active and not cancelled */}
    {subscriptionStatus !== 'cancelled' && !isExpired && (
      <li>
        <a className="btn btn-primary w-10 w-md-auto" onClick={handle_renew}>
          Renew
        </a>
      </li>
    )}

    {/* Show Cancel if active and not cancelled */}
    {subscriptionStatus !== 'cancelled' && new Date(expiry_date) >= new Date() && (
      <li>
        <a className="btn btn-primary w-10 w-md-auto" onClick={handle_cancel}>
          Cancel
        </a>
      </li>
    )}
  </ul>

  {/* Confirmation Modal for Cancel */}
  {showModal && (
    <ConfirmationModal
      onCancel={handleCancelModal}
      onConfirm={handleConfirmCancel}
      message="Are you sure you want to cancel your subscription?"
    />
  )}

  {/* Error or info messages */}
  {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
  {linkMessage && <p style={{ color: 'red' }}>{linkMessage}</p>}
</div>
</section>


 {user?.email === 'smmanik0075@gmail.com' && (<section className="data-table"> 
      <h4>Configure Brokerage Account</h4>
      <div className="form-section">
        <div className="form-row package-header">
          <label htmlFor="brokerage-select">Select Brokerage Site</label>
          <select
            id="brokerage-select"
            name="brokerage_list"
            value={selectedBrokerage}
            onChange={handleBrokerageChange}
          >
            <option value="">-- Select Brokerage --</option>
            {DSE_BROKERAGES.map((brokerage) => (
              <option key={brokerage.id} value={brokerage.id}>
                {brokerage.name}
              </option>
            ))}
          </select>
        </div>

        <p style={{ fontSize: '16px', color: '#999' }}>
          * Select and login to your brokerage account using the above list to allow sending buy/sell orders
          right from TradeBarta.com
        </p>
      </div>
    </section>)}

<section className="data-table">
  <h4>Configure Notification</h4>
  <div className="form-section">
    <div className="form-row package-header">
      <label>Phone / Telegram Number</label>
      <input
        type="text"
        name="phone_number"
        placeholder="Phone Number"
        value={phoneNumber}
        onChange={handlePhoneChange}
        inputMode="numeric"
        className="input-phone"
      />
    </div>

    <div className="form-row checkbox-group">
  <label>Price Notifications</label>

  <label>
    <input
      type="radio"
      name="notify_medium"
      value={1}
      checked={notifyMedium === 1}
      onChange={() => setNotifyMedium(1)}
    />
    Telegram
  </label>

<label>
  <input
    type="radio"
    name="notify_medium"
    value={2}
    checked={notifyMedium === 2}
    onChange={() => setNotifyMedium(2)}
    disabled={isFree}
  />
  {isFree ? 'SMS (Paid Plans Only)' : 'SMS'}
</label>
  
  {!isFree && (
    <p style={{ fontSize: '16px', color: '#999' }}>
      * News notifications will be sent via Telegram only
    </p>
  )}
</div>

    <button
      type="button"
      onClick={handleSavePhone}
      disabled={isExpired}
      style={{
        width: '150px',
        marginTop: '14px',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        backgroundColor: isExpired ? '#ccc' : '#007bff',
        color: isExpired ? '#666' : 'white',
        cursor: isExpired ? 'not-allowed' : 'pointer'
      }}
    >
      Save
    </button>

    {saveMessage && (
      <p
        style={{
          color: saveMessage.includes('successfully') ? 'green' : 'red',
          textAlign: 'center',
          marginTop: '8px'
        }}
      >
        {saveMessage}
      </p>
    )}

    {telegramLink && (
      <div>
        <p>
          For Notifications on Telegram:  
          <button
            className="btn btn-primary w-10 w-md-auto"
            style = {{marginLeft: '10px'}}
            onClick={() => window.open(telegramLink, "_blank")}
          >
            Link your Telegram
          </button>
        </p>
        <p>Same Link also sent to email</p>
      </div>
    )}
  </div>
</section>
        <section className="data-table">
          <h4>Configure Stocks</h4>
          <div className="responsive-table-container">
          <table>
            <thead>
              <tr>
                <th>Stock Name</th>
                <th>Buy Alert Price</th>
                <th>Sell Alert Price</th>
                <th>% Change Alert</th>
               {/* <th>Price Alert</th> */}
                <th>News Alert</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.item}</td>
                  <td>{row.buy_price}</td>
                  <td>{row.sell_price}</td>
                  <td>{row.percent_change}</td>
                  {/*<td><input type="checkbox" name="price_notify" checked={row.price_notify} onChange={() => handleCheckboxToggle(idx, 'price_notify')} /></td>*/}
                  <td><input type="checkbox" name="news_notify" checked={row.news_notify} onChange={() => handleCheckboxToggle(idx, 'news_notify')} /></td>
                  <td>
                    <button onClick={() => handleEdit(idx)}>Edit</button></td>
                    <td><button onClick={() => handleDelete(idx)}>Delete</button>
                  </td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan="4" style={{ textAlign: 'center' }}>No data yet</td></tr>
              )}
            </tbody>
          </table>
          </div>
          <div style={{ textAlign: 'center', marginTop: '14px' }}>
            <button type="button" onClick={handleSavePortfolio} disabled={isExpired} 
                style={{ width: '150px', marginTop: '14px', marginLeft: 'auto', marginRight: 'auto', 
                display: 'block', backgroundColor: isExpired ? '#ccc' : '#007bff',
                color: isExpired ? '#666' : 'white', cursor: isExpired ? 'not-allowed' : 'pointer'}}>
            Save
           </button>
          {stockSaveMessage && <p style={{ marginTop: '10px', color: 'green' }}>{stockSaveMessage}</p>}

            </div>
        </section>

        <section className="data-table">
          <h4>{editingIndex !== null ? 'Edit Stock' : 'Add New Stock'}</h4>
  {limitMessage && (
    <div style={{ textAlign: 'center', color: 'red', marginTop: '8px' }}>{limitMessage}</div>
  )}
          <div className="form-row responsive-form">
          <select
            value={selected}
            onChange={(e) => setSelected(e.target.value)}
          >
        <option value="">-- Select --</option>
        {options.map((option) => (
          <option key={option.id} value={option.name}>
            {option.name}
          </option>
        ))}
      </select>
 
            <input
              type="text"
              name="buy_price"
              title="Get notified to buy when price reaches this value"
              placeholder="Buy Alert Price"
              value={form.buy_price}
              inputMode="decimal"
              onChange={handleBuyPriceChange}
            />
            <input
              type="text"
              name="sell_price"
              title="Get notified to sell when the price reaches this value"
              placeholder="Sell Alert Price"
              value={form.sell_price}
              inputMode="decimal"
              onChange={handleSellPriceChange}
            />
            <input
              type="text"
              name="percent_change"
              title="Get notified when daily price increases/decreases by this %"
              placeholder="% Change Alert"
              value={form.percent_change}
              inputMode="decimal"
              onChange={handleMaxChange}
            />
            <button
              type="button"
              onClick={handleAdd}
              disabled={rows.length > maxRows && editingIndex === null}
            >
              {editingIndex !== null ? 'Update' : 'Add'}
            </button>

          </div>      {selected && (
      <p style = {{color: "green" }}>
        Last Trading Price:{' '}
        {
          options.find((option) => option.name === selected)?.current_price ?? 'N/A'
        }
      </p>
    )}    
        </section>
      </main>
    </div>
    </div>
  ); 
};

export default Dashboard;